import apiFetch from '@wordpress/api-fetch';

const { restRoot, nonce, pluginUrl } = window.fairplayRulesData || {};

apiFetch.use(apiFetch.createNonceMiddleware(nonce));
apiFetch.use(apiFetch.createRootURLMiddleware(restRoot));

export const PLACEHOLDER_ICONS = {
	trophy: pluginUrl ? `${pluginUrl}assets/icons/placeholder_trophy.png` : '',
	gift: pluginUrl ? `${pluginUrl}assets/icons/placeholder_gift.png` : '',
};

// Players
export const fetchPlayers = (includeArchived = false) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players${includeArchived ? '?include_archived=1' : ''}`,
	});
};

export const createPlayer = (data) => {
	return apiFetch({
		path: '/fairplay-rules/v1/players',
		method: 'POST',
		data,
	});
};

export const updatePlayer = (id, data) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${id}`,
		method: 'PUT',
		data,
	});
};

export const restorePlayer = (id) => {
	return updatePlayer(id, { archived: false });
};

export const deletePlayer = (id, permanent = false) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${id}${permanent ? '?permanent=1' : ''}`,
		method: 'DELETE',
	});
};

// Player awards (trophies & gifts)
export const fetchPlayerAwards = (playerId) => {
	return apiFetch({ path: `/fairplay-rules/v1/players/${playerId}/awards` });
};

export const awardTrophy = (playerId, data) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${playerId}/trophies`,
		method: 'POST',
		data,
	});
};

export const removePlayerTrophy = (playerId, assignmentId) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${playerId}/trophies/${assignmentId}/remove`,
		method: 'POST',
		data: {},
	});
};

export const restorePlayerTrophy = (playerId, assignmentId) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${playerId}/trophies/${assignmentId}/restore`,
		method: 'POST',
		data: {},
	});
};

export const deletePlayerTrophy = (playerId, assignmentId) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${playerId}/trophies/${assignmentId}`,
		method: 'DELETE',
	});
};

export const awardGift = (playerId, data) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${playerId}/gifts`,
		method: 'POST',
		data,
	});
};

export const removePlayerGift = (playerId, assignmentId) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${playerId}/gifts/${assignmentId}/remove`,
		method: 'POST',
		data: {},
	});
};

export const restorePlayerGift = (playerId, assignmentId) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${playerId}/gifts/${assignmentId}/restore`,
		method: 'POST',
		data: {},
	});
};

export const deletePlayerGift = (playerId, assignmentId) => {
	return apiFetch({
		path: `/fairplay-rules/v1/players/${playerId}/gifts/${assignmentId}`,
		method: 'DELETE',
	});
};


// Rules
export const fetchRules = (includeArchived = false) => {
	return apiFetch({
		path: `/fairplay-rules/v1/rules${includeArchived ? '?include_archived=1' : ''}`,
	});
};

export const createRule = (data) => {
	return apiFetch({
		path: '/fairplay-rules/v1/rules',
		method: 'POST',
		data,
	});
};

export const updateRule = (id, data) => {
	return apiFetch({
		path: `/fairplay-rules/v1/rules/${id}`,
		method: 'PUT',
		data,
	});
};

export const restoreRule = (id) => {
	return updateRule(id, { archived: false });
};

export const deleteRule = (id, permanent = false) => {
	return apiFetch({
		path: `/fairplay-rules/v1/rules/${id}${permanent ? '?permanent=1' : ''}`,
		method: 'DELETE',
	});
};

export const reorderRules = (ids) => {
	return apiFetch({
		path: '/fairplay-rules/v1/rules/reorder',
		method: 'PUT',
		data: { ids },
	});
};

// Cards
export const fetchCards = (params = {}) => {
	const query = new URLSearchParams();
	Object.entries(params).forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== '') {
			query.append(key, value);
		}
	});
	const qs = query.toString();
	return apiFetch({
		path: `/fairplay-rules/v1/cards${qs ? `?${qs}` : ''}`,
	});
};

export const createCard = (data) => {
	return apiFetch({
		path: '/fairplay-rules/v1/cards',
		method: 'POST',
		data,
	});
};

export const deleteCard = (id) => {
	return apiFetch({
		path: `/fairplay-rules/v1/cards/${id}`,
		method: 'DELETE',
	});
};

export const fetchCardSettings = () => {
	return apiFetch({ path: '/fairplay-rules/v1/cards/settings' });
};

export const updateCardSettings = (data) => {
	return apiFetch({
		path: '/fairplay-rules/v1/cards/settings',
		method: 'PUT',
		data,
	});
};

// Standings
export const fetchStandings = (playerId) => {
	const qs = playerId ? `?player_id=${playerId}` : '';
	return apiFetch({ path: `/fairplay-rules/v1/standings${qs}` });
};

// Seasons
export const fetchSeasons = () => {
	return apiFetch({ path: '/fairplay-rules/v1/seasons' });
};

export const createSeason = (data) => {
	return apiFetch({
		path: '/fairplay-rules/v1/seasons',
		method: 'POST',
		data,
	});
};

export const updateSeason = (id, data) => {
	return apiFetch({
		path: `/fairplay-rules/v1/seasons/${id}`,
		method: 'PUT',
		data,
	});
};

export const deleteSeason = (id) => {
	return apiFetch({
		path: `/fairplay-rules/v1/seasons/${id}`,
		method: 'DELETE',
	});
};

// Trophies
export const fetchTrophies = (includeArchived = false) => {
	return apiFetch({
		path: `/fairplay-rules/v1/trophies${includeArchived ? '?include_archived=1' : ''}`,
	});
};

export const createTrophy = (data) => {
	return apiFetch({
		path: '/fairplay-rules/v1/trophies',
		method: 'POST',
		data,
	});
};

export const updateTrophy = (id, data) => {
	return apiFetch({
		path: `/fairplay-rules/v1/trophies/${id}`,
		method: 'PUT',
		data,
	});
};

export const restoreTrophy = (id) => {
	return updateTrophy(id, { archived: false });
};

export const deleteTrophy = (id, permanent = false) => {
	return apiFetch({
		path: `/fairplay-rules/v1/trophies/${id}${permanent ? '?permanent=1' : ''}`,
		method: 'DELETE',
	});
};

// Gifts
export const fetchGifts = (includeArchived = false) => {
	return apiFetch({
		path: `/fairplay-rules/v1/gifts${includeArchived ? '?include_archived=1' : ''}`,
	});
};

export const createGift = (data) => {
	return apiFetch({
		path: '/fairplay-rules/v1/gifts',
		method: 'POST',
		data,
	});
};

export const updateGift = (id, data) => {
	return apiFetch({
		path: `/fairplay-rules/v1/gifts/${id}`,
		method: 'PUT',
		data,
	});
};

export const restoreGift = (id) => {
	return updateGift(id, { archived: false });
};

export const deleteGift = (id, permanent = false) => {
	return apiFetch({
		path: `/fairplay-rules/v1/gifts/${id}${permanent ? '?permanent=1' : ''}`,
		method: 'DELETE',
	});
};
